// src/index.tsx

import "./common/commonimports"
import { createRoot } from 'react-dom/client';
import { App } from './App';
import "./index.css"
import "./main.sass"
import { HashRouter } from 'react-router';
import { StrictMode } from 'react';
import '@fontsource/be-vietnam-pro/400.css';
import '@fontsource/be-vietnam-pro/500.css';
import '@fontsource/be-vietnam-pro/600.css';
// Supports weights 100-900
import '@fontsource-variable/roboto';
const container = document.getElementById('root');

if (container) {
  const root = createRoot(container);
  root.render(<StrictMode>
    <HashRouter>
      <App />
    </HashRouter>
  </StrictMode>);
}